import { Injectable } from "@angular/core";

import { Period } from "@helper/abstraction/user";

@Injectable({
	providedIn: "root"
})
export class TodayService {
	public defaultPeriod: Period = "MONTH";
	private now = new Date();
	private startDate = new Date(this.now.getFullYear(), this.now.getMonth(), this.now.getDate(), 0, 0, 0, 0);
	private endDate = new Date(this.now.getFullYear(), this.now.getMonth(), this.now.getDate(), 23, 59, 59, 59);
	private monthAgo = new Date(this.now.getFullYear(), this.now.getMonth() - 1, this.now.getDate(), 0, 0, 0, 0);
	private firstDayOfCurrentMonth = new Date(this.now.getFullYear(), this.now.getMonth(), 1, 0, 0, 0, 0);

	public set period(data: Period) {
		this.defaultPeriod = data;
	}

	public get oneMonth(): [Date, Date] {
		return this.setDefaultPeriod(this.defaultPeriod);
	}

	public get todayRange(): [Date, Date] {
		return [this.startDate, this.endDate];
	}

	public get currentMonth(): [Date, Date] {
		return [this.firstDayOfCurrentMonth, this.endDate];
	}

	private setDefaultPeriod(defaultPeriod: string): [Date, Date] {
		const today = new Date();
		let dateStart: Date;
		let dateEnd: Date;
		switch (defaultPeriod) {
			case "DAY":
				dateStart = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0, 0);
				dateEnd = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59, 59);
				break;
			case "WEEK":
				dateStart = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 6, 0, 0, 0, 0);
				dateEnd = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59, 59);
				break;
			case "MONTH":
				dateStart = this.monthAgo;
				dateEnd = this.endDate;
				break;
		}
		return [dateStart!, dateEnd!];
	}
}
